module.exports = __webpack_public_path__ + "img/744.f49e6cda.jpg";